module.exports = __webpack_public_path__ + "5e5538fa392e0c4f061b7593957990db.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/grow-business.svg
// module id = 616
// module chunks = 0